export default function (str) {
  return (str+'').replace("&nbsp;", " ").replace(/&#{0,1}[a-z0-9]+;/ig, "")
}
